














































































































import DateMixin from "@/mixins/DateMixin";
import AccountIdValdationMixin from "@/mixins/AccountIdValdationMixin";
import { DalModule } from "@/store/dal.module";
import { Component, Mixins } from "vue-property-decorator";
import MonthPicker from "@/components/ui/MonthPicker.vue";
import moment from "moment";
import { InvoiceInfo } from "~/dal/invoice.info";
import { translate } from "@/utils";
import { BaseModule } from "@/store/base.module";
import { FileService } from "@/services/file.service";
import { ReportAction } from "~/services/report";
import i18n from "@/plugins/i18n";

@Component({
  components: { MonthPicker },
  watch: {
    "period.from": "loadData",
    "period.to": "loadData",
    expanded: "expandedLoad",
  },
})
export default class InvoiceInfoView extends Mixins(
  DateMixin,
  AccountIdValdationMixin,
) {
  expanded: InvoiceInfo[] = [];
  period = {
    from: "",
    to: "",
    min: "",
    max: "",
  };
  canLoad: boolean = false;
  loading: boolean = false;

  translate(val: any) {
    return translate(val);
  }

  b64toBlob = (b64Data: string, contentType = "", sliceSize = 512) => {
    const byteCharacters = atob(b64Data);
    const byteArrays = [];

    for (let offset = 0; offset < byteCharacters.length; offset += sliceSize) {
      const slice = byteCharacters.slice(offset, offset + sliceSize);

      const byteNumbers = new Array(slice.length);
      for (let i = 0; i < slice.length; i++) {
        byteNumbers[i] = slice.charCodeAt(i);
      }

      const byteArray = new Uint8Array(byteNumbers);
      byteArrays.push(byteArray);
    }

    const blob = new Blob(byteArrays, { type: contentType });
    return blob;
  };

  async showPDF(item: InvoiceInfo, t: number) {
    try {
      BaseModule.setLoadingStatus(true);
      const tab = this.openTab("open");
      await DalModule.getInvoicePrinted({
        AccountId: item.account_id,
        BillId: t == 1 ? item.bill_id : item.bill_id2,
        year: item.year,
        month: item.month,
      }).then((res) => {
        const contentType = "image/jpg";

        const blob = this.b64toBlob(res.value, contentType);
        //const blobUrl = URL.createObjectURL(blob);
        //window.open(blobUrl);

        FileService.openPdfInNewTab(blob, tab);
      });
    } finally {
      BaseModule.setLoadingStatus(false);
    }
  }

  openTab(action: ReportAction) {
    if (action != "open") return null;

    const tab = window.open("", "_blank");
    if (!tab) return null;

    tab.document.title = "Идет загрузка...";
    const container = tab.document.createElement("div");
    container.innerHTML = `
          <p>${i18n.t("ui.document_loading")}</p>
        `;
    tab.document.body.append(container);
    return tab;
  }

  async expandedLoad() {
    this.expanded.forEach(async (el: InvoiceInfo) => {
      if (el && el.details && el.details.length == 0 && !el.detailsLoading) {
        try {
          el.detailsLoading = true;
          el.details = await DalModule.getInvoiceServices({
            bill_id: el.bill_id,
            Year: el.year,
            Month: el.month,
          });
        } finally {
          el.detailsLoading = false;
        }
      }
    });
  }

  get invoiceListLoading() {
    return DalModule.invoiceListLoading;
  }

  get invoiceInfoList() {
    return DalModule.invoiceInfoList;
  }

  get invoiceInfoLength() {
    return DalModule.invoiceInfoLength;
  }

  get headers() {
    return [
      {
        text: this.$t("invoices.year-month"),
        value: "yearMonth",
        sortable: false,
      },
      {
        text: this.$t("invoices.fix_summ"),
        value: "fix_summ",
        align: "right",
      },
      {
        text: this.$t("invoices.kvit"),
        value: "kvit",
        align: "center",
        sortable: false,
        width: 150,
      },
      {
        text: this.$t("invoices.oborot"),
        value: "oborot",
        align: "center",
        sortable: false,
        width: 150,
      },
      { text: "", value: "data-table-expand" },
    ];
  }

  async mounted() {
    DalModule.setInvoiceInfoList();
    const today = new Date();
    this.period.to = moment(today).format("YYYY-MM");
    this.period.from = moment(today).add(-3, "M").format("YYYY-MM");
    this.period.min = moment(today).add(-35, "M").format("YYYY-MM");
    this.period.max = moment(today).format("YYYY-MM");
    await this.validateAccountId();
    if (!this.$route.params.id) {
      this.$router.push({ name: "account-list" });
      return;
    }
    const acc = Number.parseInt(this.$route.params.id);
    if (acc) {
      DalModule.setAccountId(acc);
    }
    this.canLoad = true;
    await this.loadData();
  }

  async loadData() {
    try {
      DalModule.setInvoiceListLoading(true);
      DalModule.setInvoiceInfoList();
      if (this.canLoad)
        await DalModule.getAccountInvoices({
          Account_id: DalModule.AccountId,
          MonthFrom: moment(this.period.from).month() + 1,
          YearFrom: moment(this.period.from).year(),
          MonthTo: moment(this.period.to).month() + 1,
          YearTo: moment(this.period.to).year(),
        });
    } finally {
      //
    }
  }
}
